<template>
    <div >
      <MdTitle v-bind:Text="$t('schedulerDailyRep.ReportTitle')" />
      <div class="row">
        <div class="col-sm-12 col-md-12 mb-4">
          <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
            <div class="input-group" dir="ltr">
              <input 
                type="text" 
                class="form-control"
                :dir="dirInput"
                v-model="parameter.SearchCriteria"   
                  @keyup.enter="SearchAppoinments"                            
              >
              <div class="input-group-append">
                <div class="input-group-append">
                  <MdButton 
                    v-bind:Name="'btnsearchinput'"
                    v-bind:VariantProp="'btn btn-sm search-attached'"
                    v-bind:IconClass="'mdi mdi-magnify'"
                    v-on:click="SearchAppoinments">
                  </MdButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="true">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="true">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Employee',2)"
              v-bind:Options="employeesOptions"
              v-bind:FieldDescription="'employeeName'"
              v-bind:FieldCode="'employeeCode'"
              v-bind:Model="employees"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownEmployees"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.AppointmentType')"
              v-bind:Options="AppointmentTypesOptions"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Model="appointmentTypes"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownAppointmentType"
            />
          </b-col>          
      </b-row>
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="patientOptions"
              v-bind:FieldDescription="'PatientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Model="patient"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.Program',2)"
              v-bind:Options="programOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:ModelArray="program"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownProgram"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$t('schedulerDailyRep.Reason')"
              v-bind:Options="reasonOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="reason"                       
              v-bind:Multiple="true"
              :Input="ChangeDropDownReason"
            />
          </b-col>
          <b-col v-if="useBranchLocations" md="3" lg="3s" sm="12">
            <MdSelect
              v-bind:Label="$t('schedulerDB.AppointmentLocation')"
              v-bind:Options="AppointmentLocationList"
              v-bind:Model="AppointmentLocationVmodel"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Multiple="true"
              v-bind:RequireEvent="true"
              v-bind:IfUsevalidation="false"
              :Input="ChangeDropDownAppointmentLocation"/>
          </b-col>
        </b-row>
          
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('schedulerDailyRep.ShowedUp')"
              v-model="showedup"
              v-bind:Options="showedupOptions"
              v-bind:Name="'showedup'"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('schedulerDailyRep.Confirmed')"
              v-model="confirmed"
              v-bind:Options="confirmedOptions"
              v-bind:Name="'confirmed'"
            />
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('ChartReview.OrderBy')"
              v-model="order"
              v-bind:Options="orderOptions"
              v-bind:Name="'order'"
            />
          </b-col>
         <b-col>
            <div class="text-md-right">
                <button 
                    v-on:click="SearchAppoinments"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
               
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/> 
            
          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('schedulerDailyRep.RepTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportSchedulerDaily"
          :ReportName="'DailyScheduler'"
          :ReportTitle="$t('schedulerDailyRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

     <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('schedulerDailyRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Schedulers/email'"
        v-bind:exportCsvAPI="'/Schedulers/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import Utils from '../../../common/utils'
    import ClinicalService from '@/services/clinical.service'
    import CalendarResourcesService from '@/services/calendarresources.service'
    import AppointmentTypes from '@/services/appointmenttypes.service'
    import ReasonService from '@/services/reason.service'
    import PatientService from '@/services/patient.service'
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import DBFunctions from '@/common/DBFunctions.js'
    import SchedulersService from '@/services/schedulers.service'
    import { EventBus } from '@/event-bus.js';
    import ProviderService from '@/services/provider.service'
    import BranchLocation from '@/services/branchlocation.service'

    export default Vue.extend({
        name: "schedulerDailyFiltersRep",
        mixins: [ ShowMessage, DBFunctions ],
        components: { DxPopup },
        data() {
            return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: Utils.formatterDate(new Date()),
              dateTo: Utils.formatterDate(new Date()),
              reportParams: [],
              patientOptions: [{}],
              programOptions: [{}],
              patient: null,
              program: null,
              AppointmentTypesOptions: [{}],
              reasonOptions: [{}],
              appointmentTypes: null,
              reason: null,
              employeesOptions: [{}],
              employees: null,
              showedupOptions: [
                { value: 'all', text: this.$t('Shared.All') },
                { value: 'T', text: this.$t('Shared.Show') },
                { value: 'F', text: this.$t('schedulerDailyRep.NoShow') },
              ],
              confirmedOptions: [
                { value: 'all', text: this.$t('Shared.All') },
                { value: 'T', text: this.$t('schedulerDailyRep.Confirmed') },
                { value: 'F', text: this.$t('schedulerDailyRep.NoConfirmed') }
              ],
              showedup: 'all',
              confirmed: 'all',
              orderOptions: [
                { value: 'time', text: this.$t('Incident.IncTime') },
                { value: 'appttype', text: this.$tc('Shared.AppointmentType') },
                { value: 'patientname', text: this.$t('Shared.PatientName') }
              ],
              order: 'time',
              appt: false,
              page: false,
              showAddress: false,
              checkboxesOptions: [ 
                  this.$t('schedulerDailyRep.ShowApptTpe'),
                  this.$t('schedulerDailyRep.RemovePeB'),
                  this.$t('schedulerDailyRep.ShowPatiAddre')
              ],
              checkboxes: null,
              programParam: '',
              employeeParam: '',
              appointmentTypeParam: '',
              reasonParam: '',
              patientParam: '',
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0,
                Status: true,       
              },
              items: [],         
              fields: [
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' } ,
                { key: 'patientcode', sortable: true, label: this.$t('Shared.PatientCode'), class: 'text-rigth' } , 
                { key: 'dob', sortable: true, label: this.$t('Shared.DOB'), class: 'text-rigth' } ,              
                { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone') , class: 'text-left' },
                { key: 'daY_PHONE', sortable: true, label: this.$t('Shared.DayPhone'), class: 'text-left' },
                { key: 'night_Phone', sortable: true, label: this.$t('Shared.NightPhone'), class: 'text-left' },
                { key: 'email', sortable: true, label: this.$t('Shared.Email'), class: 'text-left' },
                { key: 'program', sortable: true, label: this.$tc('Shared.Program'), class: 'text-left' },
                { key: 'activitytypename', sortable: true, label: this.$tc('Appointments.Appo'), class: 'text-left' },
                { key: 'activitytypecode', sortable: true, label: this.$tc('Shared.AppointmentType'), class: 'text-left' },
                { key: 'private', sortable: true, label: this.$t('Appointments.showUp'), class: 'text-left' },
                { key: 'isConfirmed', sortable: true, label: this.$t('Appointments.confirm'), class: 'text-left' },
                { key: 'contact', sortable: true, label: this.$tc('Contact.Contact'), class: 'text-left' },
                // { key: 'startDate', sortable: true, label: this.$t('Medication.StartDate'), class: 'text-rigth' }, 
                // { key: 'endDate', sortable: true, label: this.$t('Medication.EndDate'), class: 'text-rigth' },
                { key: 'startDateTime', sortable: true, label: this.$t('Medication.StartDateAndTime'), class: 'text-left' },
                { key: 'endDateTime', sortable: true, label: this.$t('Medication.EndDateAndTime'), class: 'text-left' },
                // { key: 'timein', sortable: true, label: this.$t('MdNote.STARTTIME'), class: 'text-left' },
                // { key: 'timeout', sortable: true, label: this.$t('MdNote.ENDTIME'), class: 'text-left' },
                { key: 'therapistName', sortable: true, label:  this.$tc('Shared.Therapist'), class: 'text-left' },
                { key: 'reasonName', sortable: true, label: this.$t('schedulerDailyRep.Reason'), class: 'text-left' },
                { key: 'notes', sortable: true, label: this.$tc('Shared.Note',2), class: 'text-left' }
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            selected: [],
            Header:{},
            refTable: 'selectableTable', 
            ShowMessageIsEmpty:true,
            FieldsDateArr:['dob','startDate','endDate'],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            useBranchLocations: false,
            AppointmentLocationList: [],
            AppointmentLocationVmodel: '',
            locationParam: null,
          }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
            },

            ChangeDropDownPatients(value) {
              this.patientParam = [];
              let selectedPatient = [];
              value.forEach(function(item) {   
                selectedPatient.push(item.patientcode);               
              });

              this.patientParam = selectedPatient;
            },
            customLabelPatients ({ PatientName, patientcode }) {
              return `${PatientName} – ${patientcode}`
            },
            ChangeDropDownProgram(value) {
              this.programParam = [];
              let selectedProgram = [];
              value.forEach(function(item) {   
                selectedProgram.push(item.code);               
              });

              this.programParam = selectedProgram;
            },

            ChangeDropDownReason(value) {
              this.reasonParam = [];
              let selectedReason = [];
              value.forEach(function(item) {   
                selectedReason.push(item.code);               
              });

              this.reasonParam = selectedReason;
            },

            ChangeDropDownEmployees(value) {
              this.employeeParam = [];
              let selectedEmployees= [];
              value.forEach(function(item) {   
                selectedEmployees.push(item.employeeCode);               
              });

              this.employeeParam = selectedEmployees;
            },

            ChangeDropDownAppointmentType(value) {
              this.appointmentTypeParam = [];
              let selectedApptTypes= [];
              value.forEach(function(item) {   
                selectedApptTypes.push(item.code);               
              });

              this.appointmentTypeParam = selectedApptTypes;
            },

            getPrograms(){
              const parameter = {
                  programsRestriction:  this.$store.state.restrictions.programs
              }
              ClinicalService.getPrograms(parameter)
                .then((response) => {
                     if(response.status == '200' && response.data && response.data.length > 0){
                       this.programOptions = response.data;                                
                     }               
                })
                .catch(error => {
                    if (!error.response) {
                    // network error
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                    } else {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                });  
            },

            getEmployees() { 
              CalendarResourcesService.getAll()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.employeesOptions = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            getAppointmentTypes() { 
              AppointmentTypes.getAll()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.AppointmentTypesOptions = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            getReason() { 
              ReasonService.getAll()
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.reasonOptions = response.data;
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            getPatients() { 
              PatientService.getAll(this.parameter)
              .then((response) => {
                if(response.status == '200' && response.data && response.data.length > 0){
                  this.patientOptions = response.data;
                  this.patientOptions.forEach(function(element) {
                    element.PatientName = element.firstname + " " + element.lastname;   
                  });
                }
              })
              .catch(error => {
                if (!error.response) {
                // network error
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                } else {
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });
            },

            onClickClose() {
              this.isParamVisible = false;
            },

            reportList() {
                this.checkExistFavorite('/app/reports/patients');
                this.$router.push({ name: "reportListPatient" }).catch(()=>{});
            },

            initializePdfParameters() {
              this.reportParams = []
              this.reportParams.push({ paramName: 'startDate', paramValue: this.dateFrom})
              this.reportParams.push({ paramName: 'endDate', paramValue: this.dateTo})
              this.reportParams.push({ paramName: 'program', paramValue: this.programParam})
              this.reportParams.push({ paramName: 'employee', paramValue: this.employeeParam})
              this.reportParams.push({ paramName: 'apptType', paramValue: this.appointmentTypeParam})
              this.reportParams.push({ paramName: 'reason', paramValue: this.reasonParam})
              this.reportParams.push({ paramName: 'patient', paramValue: this.patientParam})
              this.reportParams.push({ paramName: 'showedup', paramValue: this.showedup})
              this.reportParams.push({ paramName: 'confirmed', paramValue: this.confirmed})
              this.reportParams.push({ paramName: 'order', paramValue: this.order})
              this.reportParams.push({ paramName: 'searchcriteria', paramValue: this.parameter.SearchCriteria})
              this.reportParams.push({ paramName: 'branchLocations', paramValue: this.locationParam})
            },

            initializeParameters() {
             
              this.parameter.apptType = this.appointmentTypeParam && this.appointmentTypeParam !== '' 
                  ? this.appointmentTypeParam
                  : null;
              this.parameter.program = this.programParam && this.programParam !== '' 
                  ? this.programParam 
                  : null;
              this.parameter.employee = this.employeeParam && this.employeeParam !== '' 
                  ? this.employeeParam
                  : null;
              this.parameter.patient = this.patientParam && this.patientParam !== '' 
                  ? this.patientParam 
                  : null;
              this.parameter.reason = this.reasonParam && this.reasonParam !== '' 
                  ? this.reasonParam
                  : null;
              this.parameter.startDate = this.dateFrom;
              this.parameter.endDate = this.dateTo;
              this.parameter.showedup = this.showedup;
              this.parameter.confirmed = this.confirmed;
              this.parameter.order = this.order;
              this.parameter.branchLocations =  this.locationParam 
            
            },

            onClickShowReport() {
              this.isParamVisible = false
              this.initializePdfParameters()
              this.isReportVisible = true
              this.$refs.reportSchedulerDaily.buildDocument(this.reportParams)
            },

            SearchAppoinments(){
              this.$emit('load', true);
              this.items = [];
              this.currentPage = 1;
              this.parameter.PageNumber = 1;
              this.totalRows = this.items.length;
              this.getAppoinments();
            },

            pageChanged (page) {            
              this.currentPage = page;    
              this.getAppoinments();     
            },

            PerPageFunction(perpage){
              this.perPage = perpage;  
              this.currentPage = 1;
              this.getAppoinments();  
            },

            async getAppoinments() {
              this.parameter.PageNumber = this.currentPage;
              this.parameter.PageSize = this.perPage;

              this.initializeParameters();   
              
              await SchedulersService.getAppointmentsReportList(this.parameter, true)
                .then((response) => {
                  if (response.status == "200" && response.data && response.data.length > 0) {
                    this.items = response.data; 
                    this.totalRows =  this.items[0].maxRows;  
                    this.items.forEach(function(element) {
                        let { dob, startDate, endDate, endDateTime, startDateTime } = element
                        if (dob) element.dob = Utils.formatterDateToString(dob);  
                        if (startDate) element.startDate = Utils.formatterDateToString(startDate);        
                        if (endDate) element.endDate =  Utils.formatterDateToString(endDate);
                        if (endDateTime) element.endDateTime =  Utils.formatterDateTimeToString(endDateTime);   
                        if (startDateTime) element.startDateTime =  Utils.formatterDateTimeToString(startDateTime);      
                    });
                  }
                  if(this.items.length === 0){
                    this.ShowMessageIsEmpty = true;
                  }
                  this.$emit('load', false);
                })
                .catch((error) => {
                  this.$emit('load', false);
                  /*if (!error.response) {            
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                  } else {
                      this.showMessage(this.$tc('Msg.Error'),error,"error");
                  }*/
                  this.showResponseErrorMessage(error);
                });
            },
              
            handleCSV(action) {
              this.initializeParameters();
              try {
                switch(action) {
                  case 'export':
                      this.$refs.csvExportHelper.exportCSV(this.parameter);
                  break;
                  case 'email':
                      this.$refs.csvExportHelper.emailCSV(this.parameter);
                  break;
                  default:
                      console.warn('unknow action:', action);
                  break;
                }
              } catch (error) {
                  this.showResponseErrorMessage(error);
              }
            },
            
            handlePdf(action) {
              this.initializePdfParameters();
              try {
                switch(action) {
                  case 'export':
                      this.$refs.csvExportHelper.exportToPdf('DailyScheduler', true, false, this.reportParams);
                    break;
                  case 'email':
                      this.$refs.csvExportHelper.emailPdf('DailyScheduler', true, false, this.reportParams);
                    break;
                  default:
                      console.warn('unknow action:', action);
                    break;
                }
              } catch (error) {
                 this.showResponseErrorMessage(error);
              }
            },

            async getProvider(){
              await ProviderService.get(this.$store.state.providerCode)
                    .then((response) => {      
                      if (response.status == '200' && response.data) { 
                          this.useBranchLocations = response.data.useBranchLocations;
                      }  
                })
                .catch(error => { 
                  if (!error.response) {                      
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                            }                      
                            else if(error.response.status === 400 ){
                              this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                            } else if(error.response.status === 500){
                                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                            } else{
                                this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                            }                  
                });
                    
            },

            branchLocation() {
              if(this.$store.state.branchlocationwasloaded){
                    this.AppointmentLocationList = this.$store.state.branchlocationsList;
                }else{
                    BranchLocation.GetBranchLocations()
                    .then((response) => {
                        if(response.status == '200'){
                          this.AppointmentLocationList = response.data;                     
                          this.$store.commit('initBranchLocationList')
                          this.$store.commit('setBranchLocationwasloaded',true);  
                          response.data.forEach(element => {
                            this.$store.commit('setBranchLocationList',element);
                          });
                        }
                  })          
                  .catch((error) => {
                      if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                  });   
                } 
            },
          
            ChangeDropDownAppointmentLocation(options) {
              this.AppointmentLocationVmodel = options;
              this.locationParam = "";
              var temp = [];
              options.forEach(function(e) {   
                temp.push(e.code.trim());
              })
              this.locationParam = temp.join(',');
            },
        },
        
        mounted () {
          this.getPrograms()
          this.getEmployees()
          this.getAppointmentTypes()
          this.getReason()
          this.getPatients();
          this.getProvider()
          this.branchLocation()
          EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
          }.bind(this));
         
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
